/* mo-bf-hero-brand: Black Friday 2026 brand hero behaviour (lane brandhero).
   Loaded only while the hero renders. No library. Everything here is optional polish:
   - odometer: dealer-brand deal digits roll once into place (the server text is the final string; screen readers
     keep a plain copy), skipped under reduced motion, Save-Data, or when the script arrives late.
   - countdown to 11:59:59 pm America/New_York on the ledger end day (data-end), every second; once a minute and
     without seconds under reduced motion. Hidden when the time is up. The server HTML already says "Ends <date>".
   - "Shop the lineup" scrolls to the section after the hero (no edit to the lineup section), clearing a sticky header.
   - Save-Data: no ambient loop. */
(function () {
  'use strict';
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function nyOffsetMin(ts) {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {};
      f.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
      var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
      return Math.round((asUTC - ts) / 60000);
    } catch (e) { return -300; }
  }
  function deadline(ymd) {
    if (!/^\d{8}$/.test(ymd)) return 0;
    var y = +ymd.slice(0, 4), m = +ymd.slice(4, 6), d = +ymd.slice(6, 8);
    var guess = Date.UTC(y, m - 1, d, 23, 59, 59);
    return guess - nyOffsetMin(guess) * 60000;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function countdown(root) {
    var el = root.querySelector('[data-bfh-count]');
    var end = deadline(root.getAttribute('data-end') || '');
    if (!el || !end) return;
    el.setAttribute('aria-hidden', 'true');
    var slow = mqReduce.matches;
    var timer = 0;
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var txt;
      if (slow) {
        txt = (d ? d + (d === 1 ? ' day ' : ' days ') : '') + h + ' hr ' + m + ' min left';
      } else {
        txt = (d ? d + (d === 1 ? ' day ' : ' days ') : '') + pad(h) + ':' + pad(m) + ':' + pad(sec) + ' left';
      }
      if (el.textContent !== txt) el.textContent = txt;
      el.hidden = false;
    }
    tick();
    timer = setInterval(tick, slow ? 60000 : 1000);
  }

  function odometer(root) {
    if (!root.hasAttribute('data-odometer') || mqReduce.matches || saveData) return;
    var now = (window.performance && performance.now) ? performance.now() : 0;
    if (now > 1100) return; // arrived after the entrance: leave the final text as it is
    var deal = root.querySelector('[data-bfh-deal]');
    if (!deal || deal.getAttribute('data-built')) return;
    var txt = deal.textContent.replace(/\s+/g, ' ').trim();
    if (!/\d/.test(txt)) return;
    var i = 0;
    var nums = deal.querySelectorAll('.mo-bfh__n');
    for (var q = 0; q < nums.length; q++) {
      var src = nums[q].textContent;
      nums[q].textContent = '';
      for (var k = 0; k < src.length; k++) {
        var ch = src.charAt(k);
        if (/\d/.test(ch)) {
          var dgt = +ch;
          var w = document.createElement('span');
          w.className = 'mo-bfh__dg';
          var r = document.createElement('span');
          r.className = 'mo-bfh__reel';
          r.style.setProperty('--i', i++);
          var html = '';
          [6, 7, 8, 9, 0].forEach(function (o) { html += '<b>' + ((dgt + o) % 10) + '</b>'; });
          r.innerHTML = html;
          w.appendChild(r);
          nums[q].appendChild(w);
        } else {
          nums[q].appendChild(document.createTextNode(ch));
        }
      }
    }
    var vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');
    while (deal.firstChild) vis.appendChild(deal.firstChild);
    var sr = document.createElement('span');
    sr.className = 'mo-bfh__sr';
    sr.textContent = txt;
    deal.appendChild(sr);
    deal.appendChild(vis);
    deal.setAttribute('data-built', '1');
  }

  function stickyOffset() {
    var max = 0;
    var els = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper');
    for (var i = 0; i < els.length; i++) {
      var cs = getComputedStyle(els[i]);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var b = els[i].getBoundingClientRect();
        if (b.height > 0 && b.height < 260) max = Math.max(max, b.height);
      }
    }
    return max;
  }

  function jump(root) {
    var links = root.querySelectorAll('[data-bfh-jump]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        var wrap = root.closest('.shopify-section') || root;
        var t = wrap.nextElementSibling;
        while (t && t.offsetHeight === 0) t = t.nextElementSibling;
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
        window.scrollTo({ top: Math.max(0, y), behavior: mqReduce.matches ? 'auto' : 'smooth' });
        var n = root.querySelector('.mo-bfh__next');
        if (n) { try { n.focus({ preventScroll: true }); } catch (err) { n.focus(); } }
      });
    }
  }

  function init(root) {
    if (root.getAttribute('data-bfh-ready')) return;
    root.setAttribute('data-bfh-ready', '1');
    if (saveData) root.classList.add('mo-bfh--still');
    odometer(root);
    countdown(root);
    jump(root);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-mo-bf-hero]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
